import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

const StyledHeroSection = styled.section`
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  align-items: center;
  gap: clamp(40px, 7vw, 100px);
  min-height: 100vh;
  min-height: 100svh;
  padding: 120px 0;

  .greeting {
    margin: 0 0 18px 5px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(14px, 1.5vw, 18px);
    font-weight: 400;
  }
  h1 {
    margin: 0;
    color: var(--lightest-slate);
    font-size: clamp(80px, 10.5vw, 150px);
    font-weight: 600;
    line-height: 0.95;
    letter-spacing: -0.055em;
  }
  .welcome {
    max-width: 340px;
    margin: 28px 0 0 5px;
    color: var(--light-slate);
    font-size: 21px;
    line-height: 1.5;
  }
  .welcome span {
    display: block;
    margin-top: 8px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: 12px;
  }
  .portrait {
    position: relative;
    width: 100%;
    max-width: 400px;
    justify-self: end;
    background: var(--green);
    border-radius: 3px;
  }
  .portrait::after {
    content: '';
    position: absolute;
    inset: 15px -15px -15px 15px;
    border: 1px solid #3c8d87;
    border-radius: 3px;
    z-index: -1;
  }
  .portrait-image {
    display: block;
    width: 100%;
    border-radius: 3px;
    mix-blend-mode: multiply;
    filter: grayscale(100%);
  }
  @keyframes hero-arrive {
    from {
      opacity: 0;
      transform: translateY(18px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @media (prefers-reduced-motion: no-preference) {
    .introduction {
      animation: hero-arrive 800ms 80ms both;
    }
    .portrait {
      animation: hero-arrive 900ms 180ms both;
    }
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    align-content: center;
    gap: 50px;
    padding: 130px 0 90px;
    .greeting {
      margin-left: 2px;
    }
    h1 {
      font-size: clamp(80px, 19vw, 130px);
    }
    .portrait {
      width: 78%;
      max-width: 330px;
      justify-self: center;
    }
  }
`;

const Hero = () => (
  <StyledHeroSection aria-label="Introduction">
    <div className="introduction">
      <p className="greeting">Hi, my name is</p>
      <h1>Alans.</h1>
      <p className="welcome">
        I love coding, games, and solving cool problems.
        <span>Welcome to my website.</span>
      </p>
    </div>
    <div className="portrait">
      <StaticImage
        className="portrait-image"
        src="../../images/me.jpg"
        width={600}
        quality={95}
        formats={['AUTO', 'WEBP', 'AVIF']}
        alt="Alans Fuentes"
        loading="eager"
      />
    </div>
  </StyledHeroSection>
);
export default Hero;
